import { Info } from 'components/common/form/modules/Info';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import {
    getInventoryItemsAsString,
    updateSellInventoryItem,
    updateLinkName,
    getPageViews,
    reorder
} from 'components/graphql/queries'
import { openModal } from 'components/modal/modules/dispatcher/methods';
import QRCode from 'qrcode.react';
import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import UserDucks from 'stores/ducks/User.duck';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';
import AffiliatesModal from './AffiliatesModal';
import CreateInventoryModal from './CreateInventory.modal';
import PassOnInventoryModal from './PassOnInventory.modal';
import UpdateInventoryModal from './UpdateInventory.modal';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import InventoryTableBody from './InventoryTableBody';

const PRIMARY_LINK_TEXT = 'My Primary Link'
const REQUEST_ERROR = 'Something went wrong, try again !'
const ADDITIONAL_LINK = '-additional-link-'

const menuBtnStyle = {
    marginTop: '3px',
    paddingLeft: '20px'
}

const InventoryTable: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [height] = useState(props.floorplan ? props.floorplan.height : 10)
    const [campaignId] = useState(props.campaignId)
    const [loading, setLoading] = useState(true)
    const [inventory, setInventory] = useState([{ name: '', id: '' }])
    const usersInit: string[] = []
    const [users, setUsers] = useState(usersInit) // sharedBy names for all ticket types
    const [userObjects, setUserObjects] = useState<any[]>([]) // sharedBy objects for all ticket types
    const [imageHeight, setImageHeight] = useState(0)
    const [data, setData] = useState([])
    const [linkName, setLinkName] = useState('')
    const [currentLinkName, setCurrentLinkName] = useState('')
    const [pageViews, setPageViews] = useState(0)
    const [selectedUserName, setSelectedUserName] = useState(props.selectedUserName)
    const [selectedUserId, setSelectedUserId] = useState(props.selectedUserId)
    const [reordering, setReordering] = useState(false)

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getInventoryItemsAsString,
                variables: {
                    campaignId,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id
                }
            })
            .then(res => {
                const inventoryItems = JSON.parse(res.data.data.inventoryItem.getInventoryAsString)
                console.log('------- Inventory Items (Line 71) -------')
                console.log(inventoryItems)
                setInventory(inventoryItems)

                // Affiliates
                const usernames: string[] = []
                const userObjs: any[] = []

                inventoryItems.map((i: any) => {
                    i.sharedBy.map((u: any) => {
                        if (!usernames.includes(u.username)) {
                            usernames.push(u.username)
                            userObjs.push(u)
                        }
                    })
                })

                setUsers(usernames)
                setUserObjects(userObjs)

                if (props.floorplan) {
                    const initData: any = []

                    props.floorplan.labels.map((item: any) => {
                        initData.push({
                            id: item.label,
                            data: [{ x: item.x, y: item.y }]
                        })
                    })
                    // const sold: any[] = []
                    inventoryItems.map((item: any) => {
                        const d: any = []

                        props.floorplan.inventoryMap.map((i: any) => {
                            if (item.id.toString().trim() === i.inventoryItemId.toString().trim()) {
                                if (i.bought) {
                                    initData.push({
                                        id: item.name + '-' + i.buyerName + '-' + i.x.toString() + i.y.toString(),
                                        data: [{
                                            x: i.x, y: i.y
                                        }]
                                    })
                                } else {
                                    d.push({
                                        x: i.x, y: i.y
                                    })
                                }
                            }
                        })

                        initData.push({
                            id: item.name,
                            data: d
                        })
                    })
                    setData(initData)
                }

                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })
    }, [setLoading, campaignId, props.user, setInventory, props.createdBy, setUsers, setData,
        props.floorplan, props.key, selectedUserName, props.createdByUsername])

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getPageViews,
                variables: {
                    campaignId,
                    sellerId: selectedUserId
                }
            })
            .then(res1 => {
                setPageViews(res1.data.data.treeNode.getPageViews)
            })
            .catch(err => {
                console.log(err)
            })
    }, [selectedUserId])

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const handleReorder = useCallback(() => {
        const orderedItems = inventory.map((x: any, i: number) => {
            return {
                inventoryItemId: x.id,
                order: i
            }
        })

        setReordering(true)

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: reorder,
                variables: {
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id,
                    campaignId,
                    inventoryItems: orderedItems
                }
            })
            .then(res => {
                setReordering(false)
                if (res.data.data.inventoryItem.reorder) {
                    props.reloadData()
                } else {
                    alert('Failed to re-order items')
                }
            })
            .catch(err => {
                setReordering(false)
                alert('Errors encountered when re-ordering items')
                console.log(err)
            })
    }, [inventory, props.user.isAdmin, props.createdBy, props.user.id, campaignId, props.reloadData])

    const handleLinkNameUpdate = useCallback(() => {

        if (linkName === '') {
            return alert('Link name is required')
        }

        if (linkName.includes('-')) {
            return alert('Link name must not contain -')
        }

        const { userId } = userObjects.find((u: any) => u.username === selectedUserName)

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateLinkName,
                variables: {
                    userId,
                    linkName
                }
            })
            .then(res => {
                if (res.data.data.user.updateLinkName) {
                    window.location.reload()
                } else {
                    return alert(REQUEST_ERROR)
                }
            })
            .catch(err => {
                console.log(err)
                setLinkName('')
                alert(REQUEST_ERROR)
            })
    }, [selectedUserName, linkName])

    const openLinkAsQRCode = useCallback((link: any) => {
        const content = <div style={{ textAlign: 'center' }}>
            <QRCode
                renderAs="svg"
                value={link}
                size={250}
            />
        </div>
        openModal(content, "SCAN QR CODE TO VIEW SALES PAGE", [])
    }, [])

    const openPassOnInventoryModal = useCallback(() => {
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            currentAffiliates={userObjects}
            inventory={inventory}
        />
        openModal(content, "SHARE TICKETS WITH AFFILIATES", [])
    }, [campaignId, props.reloadData, props.createdBy, inventory, userObjects])

    const openNewLinkModal = useCallback(() => {
        const name = props.user.isAdmin ? props.createdByUsername : props.user.username
        const id = props.user.isAdmin ? props.createdBy : props.user.id
        const links = userObjects.filter((u: any) => {
            return u.email && u.email.includes(name + ADDITIONAL_LINK)
        })
        const email = name + ADDITIONAL_LINK + (links.length.toString()) + '-' + id + "@isotope-referral-code.com"
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            inventory={inventory}
            email={email}
            forNewLink={true}
        />
        openModal(content, "NEW SALES LINK", [])
    }, [campaignId, props.reloadData, props.createdBy,
        inventory, userObjects, props.user, selectedUserName,
        props.createdByUsername])

    const handleSellChange = useCallback((inventoryItemId, sell) => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateSellInventoryItem,
                variables: {
                    inventoryItemId,
                    campaignId,
                    newSell: sell,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.updateSell) {
                    props.reloadData()
                }
            })
    }, [props.reloadData, campaignId, props.user, props.createdBy])

    const openInventoryCreationModal = useCallback(() => {
        const content = <CreateInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            isHost={props.isHost}
            createdBy={props.createdBy}
            startTime={props.startTime}
            endTime={props.endTime}
            floorplan={props.floorplan}
            fpBackground={props.fpBackground}
            inventory={inventory}
            currentAffiliates={userObjects}
        />
        openModal(content, "NEW TICKET", [])
    }, [inventory, campaignId, userObjects,
        props.isHost,
        props.reloadData, props.createdBy, props.startTime,
        props.endTime, props.floorplan, props.fpBackground])

    const openInventoryUpdateModal = useCallback((item) => {
        const passOnProps = {
            ...item,
            startTime: item.startTime ? item.startTime : props.startTime,
            endTime: item.endTime ? item.endTime : props.endTime
        }

        const sharedInventory: any[] = []

        const inventoryItem: any = inventory.find(x => x.id === item.id)

        inventoryItem.sharedBy.map((i: any) => {
            sharedInventory.push({
                ...i,
                commission: i.commission / 100,
                commissionRate: i.commissionRate !== null && i.commissionRate !== undefined
                    ? i.commissionRate
                    : null,
                maxCommission: i.maxCommission / 100,
                inventoryItemPrice: inventoryItem.price / 100,
            })
        })

        const content = <UpdateInventoryModal
            inventoryItemId={item.id}
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            floorplan={props.floorplan}
            createdBy={props.createdBy}
            fpBackground={props.fpBackground}
            inventory={inventory}
            sharedInventory={sharedInventory}
            isHost={props.isHost}
            {...passOnProps}
        />
        openModal(content, "UPDATE TICKET", [])
    }, [inventory, campaignId, props.reloadData, props.floorplan, props.isHost,
        props.endTime, props.startTime, props.fpBackground, props.createdBy])

    const openAllocateTicketsModal = useCallback((uName) => {
        const content = <PassOnInventoryModal
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
            createdBy={props.createdBy}
            inventory={inventory}
            email={uName}
            forNewLink={false}
        />

        const ownerName: any = props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim()
            ? props.createdByUsername
            : props.user.username

        const isAdditionalLink = selectedUserName.includes(ownerName + ADDITIONAL_LINK)

        const linkNumber = Number(selectedUserName.split('-')[3]) + 2

        const targetUser = selectedUserName === ownerName
            ? PRIMARY_LINK_TEXT
            : isAdditionalLink
                ? `My # ${linkNumber} Link`
                : selectedUserName

        const header = `SHARE ADDITIONAL TICKETS WITH ${targetUser}`

        openModal(content, header, [])
    }, [campaignId, props.reloadData, props.createdBy, inventory, userObjects, props.user, selectedUserName, props.createdByUsername])

    const getDescription = useCallback((node: any) => {

        let content = <div />

        const item: any = inventory.find((i: any) => {
            return i.name.toString().trim() === node.data.serieId.toString().trim()
        })

        const inventoryMapItem: any = props.floorplan ? props.floorplan.inventoryMap.find((i: any) => {
            return i.x === node.data.x && i.y === node.data.y
        }) : null

        let bidExists = false;
        let currBidLabel = 0;

        if (inventoryMapItem) {
            if (inventoryMapItem.bid && !inventoryMapItem.bought) {
                bidExists = true
                currBidLabel = inventoryMapItem.bid.currentBid
            }
        }

        if (item) {
            content = <div>
                {item.name}
                <br />
                {
                    bidExists
                        ? 'Bid $' + (currBidLabel / 100).toFixed(2)
                        : '$' + (item.price / 100).toFixed(2)
                }
                <br />
                {item.description}
            </div>
        } else {
            content = <div>
                <div>
                    {node.data.serieId.split('-')[0]}
                </div>
                <div>
                    {node.data.serieId.split('-')[1]}
                </div>
            </div>
        }

        return <div
            className='blur-safari'
            style={{
                padding: '10px',
                color: '#242d51',
                borderRadius: '15px',
                backdropFilter: 'blur(20px)',
                border: '0.4px solid #f1f1f1',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
            }}
        >
            {content}
        </div>
    }, [inventory, props.floorplan])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label: any = props.floorplan
            ? props.floorplan.labels.find((i: any) => {
                return i.label.toString().trim() === node.data.serieId.toString().trim()
            })
            : null

        const inventoryItem: any = inventory.find((item: any) => {
            return item.name.toString().trim() === node.data.serieId.toString().trim()
        })

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={inventoryItem ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={0.4}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={inventoryItem ? '#f1f1f1' : '#242d51'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }

        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [props.floorplan, inventory])

    const username: any = props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim()
        ? props.createdByUsername
        : props.user.username

    const uId: any = props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim()
        ? props.createdBy
        : props.user.id

    const usersIncludingCurrentUser = [username]

    users.map((u: any) => {
        usersIncludingCurrentUser.push(u)
    })

    const affiliates = users
        .filter(name => !name.includes(ADDITIONAL_LINK))
        .map((affiliateName, index) => {
            const affiliate = userObjects.find((u: any) => u.username === affiliateName)
            return <DropdownItem
                key={index}
                onClick={() => {
                    setLinkName('')
                    setCurrentLinkName('')
                    props.setSelectedUserName(affiliate.username)
                    props.setSelectedUserId(affiliate.userId)
                    setSelectedUserId(affiliate.userId)
                    setSelectedUserName(affiliate.username)
                }}>
                {affiliateName}
            </DropdownItem>
        })

    const yourLinks = usersIncludingCurrentUser
        .filter(name => name === username || name.includes(uId))
        .map((linkUsername, index) => {
            const isPrimaryLink = index === 0
            const link = linkUsername.split('-')[6] || linkUsername.split('-')[5]
            const linkUser = userObjects.find((u: any) => u.username === linkUsername)
            return <DropdownItem
                key={index}
                style={{
                    color: isPrimaryLink ? '#1931b9' : '#242d51'
                }}
                onClick={() => {
                    setLinkName(link)
                    setCurrentLinkName(link)
                    props.setSelectedUserId(isPrimaryLink ? uId : linkUser.userId)
                    props.setSelectedUserName(username) // different links have same sales statistics cause same user
                    setSelectedUserId(isPrimaryLink ? uId : linkUser.userId)
                    setSelectedUserName(linkUsername)
                }}
            >
                {isPrimaryLink ? PRIMARY_LINK_TEXT : `My # ${index + 1} Link (${link})`}
            </DropdownItem>
        })

    const sharedWith = userObjects.find((u: any) => {
        return u.username === selectedUserName
    })

    const usernameOrId = props.user.username !== props.createdByUsername && !props.user.isAdmin
        ? props.user.id
        : sharedWith
            ? sharedWith.userId
            : selectedUserName

    let salesLink = selectedUserName === props.createdByUsername
        ? 'https://' + props.subdomain + '.isotopeticketing.com'
        : 'https://' + props.subdomain + '.isotopeticketing.com' + '/' + usernameOrId

    const url = window.location.href.toLowerCase();
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0]

    if (subdomain === 'localhost:3000') {
        salesLink = selectedUserName === props.createdByUsername
            ? ('http://localhost:3000/sell/' + props.subdomain)
            : ('http://localhost:3000/sell/' + props.subdomain + '/' + usernameOrId)
    } else if (subdomain === 'test') {
        salesLink = selectedUserName === props.createdByUsername
            ? ('https://test.isotopeticketing.com/sell/' + props.subdomain)
            : ('https://test.isotopeticketing.com/sell/' + props.subdomain + '/' + usernameOrId)
    }

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000000"} loading={true} />
            </div>
        </div>
    }

    const sharedWithAffiliate: any[] = []
    inventory.map((item: any) => {
        item.sharedBy.map((i: any) => {
            if (i.username.toString().trim() === selectedUserName.toString().trim()) {
                sharedWithAffiliate.push({
                    ...i,
                    commission: i.commission / 100,
                    maxCommission: i.maxCommission / 100,
                    inventoryItemId: item.id,
                    inventoryItemName: item.name,
                    inventoryItemPrice: item.price / 100,
                    sell: i.sell === undefined ? true : i.sell
                })
            }
        })
    })


    const isInSalesPeriod = (item: any): boolean => {
        const currentTime = new Date()
        return currentTime >= convertToDate(item.startTime) && currentTime <= convertToDate(item.endTime)
    }

    const convertToDate = (time: any): Date => {
        return new Date(
            time.year,
            time.month - 1,
            time.day,
            time.PM ? time.hour + 12 : time.hour,
            time.minute
        )
    }

    return <div>
        <div style={{ background: 'white', paddingTop: '20px', paddingBottom: '20px' }}>
            <p style={{ margin: 0, textAlign: 'left', width: '100%', paddingLeft: '20px', paddingRight: '20px', flexDirection: 'row', display: 'flex' }}>
                <div style={{ display: 'flex', flexDirection: screen.width < 1200 ? 'column' : 'row', flex: 1 }}>
                    <div style={{ flex: 1, flexDirection: screen.width < 1200 ? 'column' : 'row', display: 'flex' }}>
                        <div style={{ float: 'left', width: 'auto' }}>
                            <p style={{ textAlign: 'left', width: 'auto' }}>
                                &nbsp;&nbsp;
                                <a href={salesLink} target='_blank' style={{ color: props.isActive ? '#1931b9' : '#565e81', textDecoration: 'underline' }}>
                                    Sales link,
                                </a>
                                &nbsp;
                                <span
                                    onClick={() => {
                                        if (!props.isActive) {
                                            return
                                        }
                                        openLinkAsQRCode(salesLink)
                                    }}
                                    style={{
                                        color: props.isActive ? '#1931b9' : '#565e81',
                                        textDecoration: 'line',
                                        cursor: 'pointer'
                                    }}>
                                    QR code
                                </span>
                                &nbsp;
                            </p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <span>
                                &nbsp;and tickets for
                            </span>
                            <span>
                                <UncontrolledDropdown style={{ paddingLeft: '10px', marginTop: '-4px' }}>
                                    <DropdownToggle className='new-button-white-4' data-toggle="dropdown" tag='button'>
                                        {
                                            selectedUserName === username
                                                ? PRIMARY_LINK_TEXT
                                                : (selectedUserName.includes(username + ADDITIONAL_LINK)
                                                    ? ("My #" + (Number(selectedUserName.split('-')[3]) + 2).toString() + " Link")
                                                    : selectedUserName)
                                        }  ▼
                                    </DropdownToggle>
                                    <DropdownMenu style={{ borderRadius: '10px' }}>
                                        <DropdownItem header={true}>Your Links</DropdownItem>
                                        {yourLinks}
                                        <DropdownItem header={true}>Team Member</DropdownItem>
                                        {affiliates}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </span>
                        </div>
                    </div>
                    <div style={{ paddingTop: screen.width < 768 ? 30 : 0, float: 'right' }}>
                        {
                            props.isActive
                                ? (selectedUserName === props.createdByUsername || selectedUserName === props.user.username)
                                    ? <span style={{ flex: 1 }}>
                                        <button
                                            className='new-button-cancel'
                                            onClick={openNewLinkModal}
                                            style={menuBtnStyle}
                                        >New Link</button>
                                        {
                                            props.user.id.toString().trim() === props.createdBy.toString().trim() || props.user.isAdmin || props.isHost
                                                ? <button
                                                    className='new-button-cancel'
                                                    onClick={openInventoryCreationModal}
                                                    style={menuBtnStyle}
                                                >New Ticket</button>
                                                : null
                                        }
                                        {
                                            props.maxLevels
                                                ? null
                                                : <button
                                                    className='new-button-cancel'
                                                    onClick={openPassOnInventoryModal}
                                                    style={menuBtnStyle}
                                                >Share With Affiliates</button>
                                        }
                                    </span>
                                    : <span style={{ flex: 1 }}>
                                        {
                                            props.maxLevels
                                                ? null
                                                : <button
                                                    className='new-button-cancel'
                                                    onClick={() => openAllocateTicketsModal(selectedUserName)}
                                                    style={menuBtnStyle}
                                                >Share Additional Tickets</button>
                                        }
                                    </span>
                                : null
                        }
                    </div>
                </div>
            </p>

            <div style={{ display: 'flex', flexDirection: screen.width < 1200 ? 'column' : 'row', flex: 1 }}>
                <div style={{ flex: 1, flexDirection: screen.width < 1200 ? 'column' : 'row', display: 'flex' }}>
                    <div style={{ marginTop: screen.width < 1200 ? '10px' : '0px', textAlign: 'left', width: '100%', paddingLeft: '26px', flexDirection: 'row', display: 'flex' }}>
                        <button
                            className='new-button-cancel'
                            style={{
                                color: 'gray',
                                paddingLeft: '3px',
                                marginLeft: '0px',
                                marginBottom: selectedUserName.includes(ADDITIONAL_LINK) ? '10px' : '20px',
                            }}
                        >
                            Page Views : <span style={{
                                marginLeft: '5px',
                                textAlign: 'left',
                                fontSize: '12px',
                                fontWeight: 'normal'
                            }}>{pageViews}</span>
                        </button>
                    </div>
                </div>
            </div>

            {
                selectedUserName.includes(ADDITIONAL_LINK) &&
                <div style={{ display: 'flex', flexDirection: screen.width < 1200 ? 'column' : 'row', flex: 1 }}>
                    <div style={{ flex: 1, flexDirection: screen.width < 1200 ? 'column' : 'row', display: 'flex' }}>
                        <div style={{ textAlign: 'left', width: '100%', paddingLeft: '26px', flexDirection: 'row', display: 'flex' }}>
                            <input
                                value={linkName}
                                type="text"
                                onChange={e => setLinkName(e.target.value)}
                                style={{
                                    margin: 0,
                                    width: '100px'
                                }}
                            />
                            <button
                                className='new-button-cancel'
                                disabled={currentLinkName === '' || currentLinkName === linkName || linkName === ''}
                                style={{
                                    marginLeft: '10px',
                                    color: currentLinkName === '' || currentLinkName === linkName || linkName === ''
                                        ? 'gray'
                                        : '#1931b9'
                                }}
                                onClick={handleLinkNameUpdate}
                            >Update Link Name</button>
                        </div>
                    </div>
                </div>
            }

            {
                (selectedUserName !== props.user.username && !props.user.isAdmin) || (props.user.isAdmin && selectedUserName !== props.createdByUsername)
                    ? <AffiliatesModal
                        reloadData={() => props.reloadData()}
                        sharedInventory={sharedWithAffiliate}
                        campaignId={campaignId}
                        createdBy={props.createdBy}
                        username={selectedUserName}
                    />
                    : <div style={{ overflow: "scroll" }}>
                        {
                            inventory && inventory.length > 0
                                ? <table className='table-responsive--base m-0' style={{ minWidth: '375px', textAlign: 'left', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ alignContent: 'center', height: 'auto', padding: '3px' }}>
                                            <td>TICKET</td>
                                            <td>PRICE</td>
                                            <td>SALES</td>
                                            <td>QTY</td>
                                            {
                                                props.user.id.toString().trim() === props.createdBy.toString().trim() || props.user.isAdmin
                                                    ? null
                                                    : <td>SHARED BY</td>
                                            }
                                            <td>HIDE</td>
                                        </tr>
                                    </thead>
                                    <InventoryTableBody
                                        createdBy={props.createdBy}
                                        user={props.user}
                                        items={inventory}
                                        setInventory={setInventory}
                                        floorplan={props.floorplan}
                                        openInventoryUpdateModal={openInventoryUpdateModal}
                                        isInSalesPeriod={isInSalesPeriod}
                                        handleSellChange={handleSellChange}
                                        handleReorder={handleReorder}
                                    />
                                </table>
                                : <p style={{ width: '100%', textAlign: 'center' }}>
                                    No tickets available
                                </p>
                        }
                        {
                            inventory && inventory.length > 0 && (props.isHost || props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim())
                                ? <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <Info >Click on a ticket to edit it.</Info>
                                </div>
                                : null
                        }
                    </div>
            }
            {
                selectedUserId === props.user.id.toString().trim() &&
                <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                    {
                        inventory.length > 0
                            ? <div style={{ width: '100%', textAlign: 'center', marginTop: 18 }}>
                                <button
                                    role="submit"
                                    type="submit"
                                    className="new-button-save"
                                    onClick={() => handleReorder()}
                                >{reordering ? 'UPDATING...' : 'UPDATE'}</button>
                            </div>
                            : null
                    }
                </div>
            }
        </div>
        {
            props.floorplan ?
                <div style={{ marginTop: '25px', padding: '20px', paddingBottom: props.fpBackground && props.fpBackground !== '' ? imageHeight + 25 : height * 26 }}>
                    <h6 style={{ textAlign: 'left', width: '100%', paddingBottom: '10px' }}>
                        SEATING LAYOUT
                    </h6>
                    <div style={{ position: 'relative', marginTop: '10px' }}>
                        <div style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
                            {
                                props.fpBackground ?
                                    <img
                                        src={props.fpBackground && props.fpBackground !== ''
                                            ? props.fpBackground
                                            : undefined}
                                        style={{
                                            width: '100%',
                                            opacity: 0.75,
                                            zIndex: 30,
                                            borderRadius: '10px',
                                            maxWidth: '100%'
                                        }}
                                        onLoad={e => onImgLoad(e)}
                                    />
                                    : null
                            }
                        </div>
                        <div style={{
                            position: 'absolute',
                            height: props.fpBackground && props.fpBackground !== ''
                                ? screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                : height * 25,
                            width: '100%',
                            opacity: 1,
                            zIndex: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            zoom: 100 / 92,
                        }}>
                            <div style={{
                                height: props.fpBackground && props.fpBackground !== ''
                                    ? screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                    : height * 25,
                                width: '100%'
                            }}>
                                <ResponsiveScatterPlot
                                    data={data}
                                    margin={{
                                        top: screen.width >= 768 ? 20 : 15,
                                        bottom: screen.width >= 768 ? 20 : 15,
                                        left: screen.width >= 768 ? 20 : 15,
                                        right: screen.width >= 768 ? 20 : 15
                                    }}
                                    enableGridX={false}
                                    enableGridY={false}
                                    xScale={{ type: 'linear', min: 0, max: props.floorplan ? props.floorplan.width - 1 : 10 }}
                                    yScale={{ type: 'linear', min: 0, max: props.floorplan ? props.floorplan.height - 1 : 10 }}
                                    axisTop={null}
                                    axisRight={null}
                                    axisLeft={null}
                                    axisBottom={null}
                                    colors={{ scheme: 'paired' }}
                                    tooltip={({ node }: any) => getDescription(node)}
                                    renderNode={CustomNode}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                : null
        }
    </div>
}

const mapStateToProps = (state: any) => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(InventoryTable);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/InventoryTable.tsx